import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mb-x6" }
const _hoisted_2 = { class: "flex items-end flex-nowrap w-full" }
const _hoisted_3 = { class: "pr-10 min-w-100 xl:min-w-120" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "flex-1 pl-10 relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputErrorMessage = _resolveComponent("InputErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Field, {
      id: _ctx.id,
      modelValue: _ctx.externalValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.externalValue) = $event)),
      name: _ctx.name,
      class: "sr-only",
      "aria-hidden": "true",
      readonly: "readonly",
      tabindex: "-1",
      disabled: ""
    }, null, 8, ["id", "modelValue", "name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_InputSelect, {
          id: '__internalCodeId__'+_ctx.id,
          modelValue: _ctx.internalCodeModel,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalCodeModel) = $event)),
          "aria-label": _ctx.$dictionary.get('Global/A11y/CountryCode'),
          name: _ctx.internalCodeFieldName,
          "show-errors": false,
          class: "w-full"
        }, {
          default: _withCtx(() => [
            (_ctx.codes.length < 1)
              ? (_openBlock(), _createElementBlock("option", _hoisted_4))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codes, (code) => {
              return (_openBlock(), _createElementBlock("option", {
                key: code,
                value: code.code
              }, _toDisplayString(code.code) + " (" + _toDisplayString(_ctx.formatCodes(code.countryCodes)) + ") ", 9, _hoisted_5))
            }), 128))
          ]),
          _: 1
        }, 8, ["id", "modelValue", "aria-label", "name"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_InputText, {
          id: '__internalPhoneId__'+_ctx.id,
          modelValue: _ctx.internalPhoneModel,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalPhoneModel) = $event)),
          name: _ctx.internalPhoneFieldName,
          label: _ctx.maybeRequiredLabel,
          "show-errors": false,
          pattern: "\\d*",
          type: "tel"
        }, null, 8, ["id", "modelValue", "name", "label"]),
        _createVNode(_component_InputErrorMessage, {
          class: "absolute mt-5 text-12",
          name: _ctx.name
        }, null, 8, ["name"])
      ])
    ])
  ]))
}